// extracted by mini-css-extract-plugin
var _1 = "ActionsPopup_icon__1TmfB";
export { _1 as "icon" }
